

import React from 'react';

class Error extends React.Component {  

    render() {  
        return (
            <div className="container h-100">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <div>
                        Erreur
                    </div>
                </div>
            </div>
        )
    }  
}

export default Error;